import { HttpDeprecatedService } from '@commons/core/transport/http-deprecated.service';
import { ILogService, IPromise, IQService } from 'angular';

export const SURVEY_FACADE_PREFIX = 'protected/survey';

export interface ISurveyService {
  getSurveyByFilter(filterForSurvey: any): IPromise<any>;

  createSurveyHistory(surveyHistory: any): IPromise<any>;

  getVocalSurveyInfo(surveyUuid: string): IPromise<any>;
}

export class SurveyService implements ISurveyService {
  static $inject: Array<string> = ['$log', '$q', 'httpDeprecated'];

  constructor(private readonly $log: ILogService, private readonly $q: IQService, private readonly httpDeprecated: HttpDeprecatedService) {}

  getSurveyByFilter(filterForSurvey: any): IPromise<any> {
    let deferred = this.$q.defer<any>();

    let _url = SURVEY_FACADE_PREFIX + '/getSurveyFiltered';
    let args = JSON.stringify(filterForSurvey);
    this.httpDeprecated
      .asPromise()
      .withConfig({
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
      })
      .withData(args)
      .post(_url)
      .then(
        success => {
          this.$log.info(`survey = ${success.data}`);
          deferred.resolve(success.data);
        },
        error => {
          this.$log.error(`survey find with [${filterForSurvey}] failed :[${JSON.stringify(error)}]`);
          deferred.reject(`survey find with [${filterForSurvey}] failed`);
        }
      );
    return deferred.promise;
  }

  createSurveyHistory(surveyHistory: any): IPromise<any> {
    let deferred = this.$q.defer<any>();

    let _url = SURVEY_FACADE_PREFIX + '/createSurveyHistory';
    let args = JSON.stringify(surveyHistory);
    this.httpDeprecated
      .asPromise()
      .withConfig({
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
      })
      .withData(args)
      .post(_url)
      .then(
        success => {
          this.$log.info(`success createSurveyHistory`);
          deferred.resolve(success.data);
        },
        error => {
          this.$log.error(`survey find with [${surveyHistory}] failed :[${JSON.stringify(error)}]`);
          deferred.reject(`survey find with [${surveyHistory}] failed`);
        }
      );
    return deferred.promise;
  }

  getVocalSurveyInfo(surveyUuid: string): IPromise<any> {
    let deferred = this.$q.defer<any>();

    let _url = SURVEY_FACADE_PREFIX + '/getVocalSurveyInformation';
    this.httpDeprecated
      .asPromise()
      .withConfig({
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
      })
      .get(_url, [surveyUuid])
      .then(
        success => {
          this.$log.info(`survey = ${success.data}`);
          deferred.resolve(success.data);
        },
        error => {
          this.$log.error(`survey find with [${surveyUuid}] failed :[${JSON.stringify(error)}]`);
          deferred.reject(`survey find with [${surveyUuid}] failed`);
        }
      );
    return deferred.promise;
  }
}

export default 'survey';
